import { Estate } from 'queries';

import Modal from 'common/modal';

import { SyncDecisionVaultModalForm } from './sync-decision-vault-modal-form';

type Props = {
  setShowModal: (value: boolean) => void;
  showModal: boolean;
  setSelectedEstate?: (value: Estate | undefined) => void;
  // indicates the user is linking matter to an existing estate
  selectedEstate?: Estate;
};

export default function SyncDecisionVaultModal({
  setShowModal,
  showModal,
  setSelectedEstate,
  selectedEstate,
}: Props) {
  const onExitClick = () => {
    if (setSelectedEstate) {
      setSelectedEstate(undefined);
    }
    setShowModal(false);
  };

  return (
    <Modal
      setShowModal={setShowModal}
      onExitClick={onExitClick}
      showModal={showModal}
      showActions={false}
      content={
        <SyncDecisionVaultModalForm selectedEstate={selectedEstate} onExitClick={onExitClick} />
      }
      loading={false}
      actionDisabled={false}
      maxWidth="md"
    />
  );
}
